import { render, staticRenderFns } from "./BoardList.vue?vue&type=template&id=25ed0ff1&scoped=true"
import script from "./BoardList.vue?vue&type=script&lang=js"
export * from "./BoardList.vue?vue&type=script&lang=js"
import style0 from "./BoardList.vue?vue&type=style&index=0&id=25ed0ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ed0ff1",
  null
  
)

export default component.exports